module.exports = __webpack_public_path__ + "static/media/blue-orange-tape-long.d10ca25c.png";